import TicketPrivileges from "../privileges";
import { TicketBodyPropTypes } from "./types";
import ReadMore from "shared/components/readMore";
import NoTicketPrivilegesAvailable from "../noPrivileges";
import {
  TICKET_CARD_DESCRIPTION_HEIGHT,
  TICKET_CARD_DESCRIPTION_LINES_3,
  TICKET_CARD_DESCRIPTION_LINES_6
} from "shared/utils/styleConstants";

function TicketBody(props: TicketBodyPropTypes) {
  return (
    <div className="ticketCard_body">
      <div className="ticketCard_bodyContent">
        <div className="ticketCard_bodyContent--desc">
          {props.description && (
            <ReadMore
              isHTMLFormatted
              content={props.description as string}
              paragraphLines={
                props.availablePrivileges?.length ? TICKET_CARD_DESCRIPTION_LINES_3 : TICKET_CARD_DESCRIPTION_LINES_6
              }
              height={props.availablePrivileges?.length ? undefined : TICKET_CARD_DESCRIPTION_HEIGHT}
            />
          )}
        </div>
        {props.availablePrivileges?.length > 0 ? (
          <div className="ticketCard_bodyContent--privilegesList">
            <TicketPrivileges
              availablePrivileges={props.availablePrivileges}
              existingPrivileges={props.existingPrivileges}
            />
          </div>
        ) : null}

        {!props.isCurrentTicket && !props.description && props.availablePrivileges?.length === 0 && (
          <NoTicketPrivilegesAvailable />
        )}
      </div>
    </div>
  );
}

export default TicketBody;
